import { ProductPrice } from '@zooplus/ui-components';

import { usePriceFormatter } from '../../hooks/usePriceFormatter';

import type { MembershipOfferPrice } from '@repo/types/membership-offer';
import type { ComponentPropsWithoutRef } from 'react';

export interface OfferPriceProps
  extends Omit<
    ComponentPropsWithoutRef<typeof ProductPrice>,
    'price' | 'previousPrice' | 'secondaryCurrencyPrice'
  > {
  price?: MembershipOfferPrice;
  referencePrice?: MembershipOfferPrice;
  secondaryCurrencyPrice?: MembershipOfferPrice;
}
export const OfferPrice = ({
  price,
  referencePrice,
  secondaryCurrencyPrice,
  ...productPriceProps
}: OfferPriceProps) => {
  const formatPrice = usePriceFormatter();

  const priceFormatted = price ? formatPrice(price.amount, price.currency) : '';
  const referencePriceFormatted = referencePrice
    ? formatPrice(referencePrice.amount, referencePrice.currency)
    : undefined;
  const secondaryCurrencyPriceFormatted = secondaryCurrencyPrice
    ? formatPrice(secondaryCurrencyPrice.amount, secondaryCurrencyPrice.currency)
    : undefined;

  return (
    <ProductPrice
      price={priceFormatted}
      previousPrice={referencePriceFormatted}
      secondaryCurrencyPrice={secondaryCurrencyPriceFormatted}
      isReducedPrice={Boolean(referencePrice)}
      {...productPriceProps}
    />
  );
};
